<template>
	<div>
		<div style="margin-top: 1.25rem; text-align: center">
			<el-radio-group v-model="radio" size="mini" @change="radioChange">
				<el-radio-button label="按组织架构"></el-radio-button>
				<el-radio-button label="按角色"></el-radio-button>
			</el-radio-group>
		</div>
		<div style="margin-top: 0.625rem">
			<el-tree
				ref="tree"
				:data="listData"
				node-key="keyId"
				:props="defaultProps"
				:highlight-current="true"
				class="eltree"
				:default-expanded-keys="expandRowKeys"
				accordion
				@node-click="nodeClick"
			></el-tree>
		</div>
		<div></div>
	</div>
</template>
<script>
import { GetOrganizationTreeList } from "../../../api/organizationalApi.js";
import { getRoleListForPage } from "../../../api/userApi.js";
export default {
	props: {},
	data() {
		return {
			formInline: {
				keyId: ""
			},
			formInlineR: {
				pageIndex: 1,
				pageSize: 9999,
				roleName: ""
			},
			listData: [],
			loading: false,
			defaultProps: {
				children: "subList",
				label: "name"
			},
			radio: "按组织架构",

			expandRowKeys: []
		};
	},
	components: {},
	created() {
		this.getListData();
	},
	methods: {
		// 切换变化
		radioChange() {
			if (this.radio === "按组织架构") {
				this.getListData();
			} else {
				this.getRoleListData();
			}
			this.$emit("radioChange");
		},

		// 节点点击
		nodeClick(row) {
			let type = 1;
			// 复制一份避免修改原数组数据
			let node = {...row};
			if (this.radio === "按组织架构") {
				if (row.parentId === "") {
					node.keyId = "";
				}
				type = 1;
			} else {
				if (row.parentId === "") {
					node.keyId = "";
				}
				type = 2;
			}
			this.$emit("nodeClick", node, type);
		},

		// 获取列表
		getListData() {
			this.listData = [];
			this.expandRowKeys = [];
			this.loading = true;
			GetOrganizationTreeList(this.formInline)
				.then((res) => {
					this.loading = false;
					if (res.code == 1) {
						this.defaultProps.label = "name";
						this.listData = res.data;
						if (this.listData && this.listData.length > 0) {
							this.expandRowKeys.push(this.listData[0].keyId);
						}
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},

		// 获取角色列表
		getRoleListData() {
			this.listData = [];
			this.loading = true;
			getRoleListForPage(this.formInlineR)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.defaultProps.label = "roleName";
						this.listData = res.data;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		}
	}
};
</script>
<style scoped>
.custom-tree-node {
	/* flex: 1; */
	display: flex;
	align-items: center;
	/* justify-content: space-around; */
	font-size: 14px;
	padding-right: 8px;
	width: 90%;
}

.span-ellipsis {
	width: 90% !important;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	display: block;
}

.span-l {
	width: 15px;
	height: 15px;
	background: #ffffff;
	display: block;
	border-radius: 10px;
	/* border-top-left-radius: 10px;
		border-bottom-left-radius: 10px; */
}

.span-r {
	width: 20px;
	height: 15px;
	background: #ffffff;
	display: block;
	border-top-right-radius: 10px;
	border-bottom-right-radius: 10px;
}
</style>
